/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/076-map': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M0 3l5-2v12l-5 2zM6 .5l5 3V15l-5-2.5zM12 3.5l4-3v12l-4 3z"/>'
  }
})
